<!-- <editor [init]='{indent: false}' apiKey="04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh" toolbar="undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist" plugins="link lists" [formControlName]="'signature'" #editor (onInit)="onEditorInit($event)"></editor> -->

<div [formGroup]='inputForm' class='LeftMessageDialog container pb-3'>
  <div class='row'>
    <div class='col col-12 col-md-4 d-flex align-items-center'>
      <mat-label for='something'>Subject:</mat-label>
    </div>
    <div class='col col-12 col-md-8'>
      <mat-form-field>
        <input formControlName='subject' id='something' matInput />
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div class='col col-12 col-md-4 d-flex align-items-center'>
      <mat-label for='something2'>Message:</mat-label>
    </div>
    <div class='col col-12 col-md-8'>
      <app-editor formControlName='message'></app-editor>
    </div>
  </div>
</div>
